import React from 'react';
import PlayGround from '../components/PlayGround';
import example from './example';


export default () => (
  <PlayGround title="List Example with hooks" code={example} />
);
